// extracted by mini-css-extract-plugin
var _1 = "LbpwHn";
var _2 = "pYYK9G";
var _3 = "shX0Vo";
var _4 = "ZR5OSN";
var _5 = "Hu9uRe";
var _6 = "kR2Xyn";
var _7 = "zQTjjJ";
var _8 = "bRlpRr";
var _9 = "Oqm3Xk";
var _a = "lMS9EX";
var _b = "uhXWLR";
var _c = "fzYi1B";
var _d = "m8t_VS";
var _e = "vjkEDH";
var _f = "jQCZMF";
var _10 = "kvp6LX";
var _11 = "_FhgU5";
var _12 = "rTHE1T";
var _13 = "kjx3XE";
var _14 = "mvlVn0";
export { _1 as "dark", _2 as "ease-transition", _3 as "fullScreenHover", _4 as "gradient-titanic-80", _5 as "hoverOpacity", _6 as "light", _7 as "linear-transition-05", _8 as "root", _9 as "roundShape", _a as "shadow-medium-titanic", _b as "shadow-medium-titanic-hover", _c as "shadow-titanic-1", _d as "shadow-white", _e as "size-104", _f as "size-16", _10 as "size-24", _11 as "size-32", _12 as "size-40", _13 as "size-56", _14 as "size-72" }
